import { CalendarEntry, TimeType } from '../types'
import { getDaysBefore } from '../getDaysBefore/getDaysBefore'
import { getMonthsBefore } from '../getMonthsBefore/getMonthsBefore'
import { getQuartersBefore } from '../getQuartersBefore/getQuartersBefore'
import { getYearsBefore } from '../getYearsBefore/getYearsBefore'

const TIME_FUNCTIONS: Record<
  TimeType,
  (date: Date, count: number, locale?: Locale) => CalendarEntry
> = {
  day: getDaysBefore,
  month: getMonthsBefore,
  quarter: getQuartersBefore,
  year: getYearsBefore
}

export function getTimeBefore(date: Date, count: number, type: TimeType, locale?: Locale) {
  const timeFunction = TIME_FUNCTIONS[type]

  if (!timeFunction) {
    throw new Error(`Invalid type '${type}' provided.`)
  }

  return timeFunction(date, count, locale)
}
